<script setup lang="ts">
import Home from '@/views/index/Home.vue';

defineOptions({
  name: 'Index',
});
</script>

<template>
  <Home />
</template>
